module.exports = __webpack_public_path__ + "img/v2-migration.b2ad68bf.png";